export const PERMISSIONS = {
  auth: {
    name: 'Authentication',
    actions: {
      all: {
        name: 'All actions',
        code: '*:auth',
      },
      revokeToken: {
        name: 'Revoke token',
        code: 'revoke-token:auth',
      },
    },
  },
  client: {
    name: 'Client',
    actions: {
      all: {
        name: 'All actions',
        code: '*:client',
      },
      read: {
        name: 'Read client',
        code: 'read:client',
      },
      create: {
        name: 'Create client',
        code: 'create:client',
      },
      update: {
        name: 'Update client',
        code: 'update:client',
      },
      delete: {
        name: 'Delete client',
        code: 'delete:client',
      },
      archive: {
        name: 'Archive client',
        code: 'archive:client',
      },
      unarchive: {
        name: 'Unarchive client',
        code: 'unarchive:client',
      },
    },
  },
  operator: {
    name: 'Operator',
    actions: {
      all: {
        name: 'All actions',
        code: '*:operator',
      },
      read: {
        name: 'Read operator',
        code: 'read:operator',
      },
      create: {
        name: 'Create operator',
        code: 'create:operator',
      },
      update: {
        name: 'Update operator',
        code: 'update:operator',
      },
      delete: {
        name: 'Delete operator',
        code: 'delete:operator',
      },
      archive: {
        name: 'Archive operator',
        code: 'archive:operator',
      },
      unarchive: {
        name: 'Unarchive operator',
        code: 'unarchive:operator',
      },
      assignRoles: {
        name: 'Assign roles to operator',
        code: 'assign-roles:operator',
      },
      unassignRoles: {
        name: 'Unassign roles to operator',
        code: 'unassign-roles:operator',
      },
    },
  },
  role: {
    name: 'Role',
    actions: {
      all: {
        name: 'All actions',
        code: '*:role',
      },
      read: {
        name: 'Read role',
        code: 'read:role',
      },
      create: {
        name: 'Create role',
        code: 'create:role',
      },
      update: {
        name: 'Update role',
        code: 'update:role',
      },
      delete: {
        name: 'Delete role',
        code: 'delete:role',
      },
      assignPermissions: {
        name: 'Assign permissions to role',
        code: 'assign-permissions:role',
      },
      unassignPermissions: {
        name: 'Unassign permissions to role',
        code: 'unassign-permissions:role',
      },
    },
  },
  report: {
    name: 'Report',
    actions: {
      all: {
        name: 'All actions',
        code: '*:report',
      },
      viewDashboard: {
        name: 'View dashboard',
        code: 'view-dashboard:report',
      },
    },
  },
};
